// Checkr Tenant order status (Checkr_Verification.status), mirrors the backend CHECKR_STATUS
export const CHECKR_STATUS = {
  REQUESTED: 'requested', // landlord asked for a background check; tenant hasn't paid yet
  WAITING_FOR_APPLICANT: 'waiting_for_applicant',
  PENDING: 'pending',
  COMPLETED: 'completed',
  CANCELED: 'canceled',
};

const CHECKR_STATUS_LABELS = {
  [CHECKR_STATUS.REQUESTED]: 'Waiting on tenant to pay',
  [CHECKR_STATUS.WAITING_FOR_APPLICANT]: 'Paid, link sent',
  [CHECKR_STATUS.PENDING]: 'Checkr processing',
  [CHECKR_STATUS.COMPLETED]: 'Report ready',
  [CHECKR_STATUS.CANCELED]: 'Canceled',
};

export const getCheckrStatusLabel = (status) => {
  if (status == null || status === '') return 'Not requested';
  return CHECKR_STATUS_LABELS[status] || String(status);
};

// No check yet, or the previous one was canceled (a canceled check can be restarted)
export const canStartBackgroundCheck = (status) => status == null || status === '' || status === CHECKR_STATUS.CANCELED;

// Checkr background check package the landlord chooses (complete = essential + income verification)
export const CHECKR_PACKAGE = {
  ESSENTIAL: 'essential',
  COMPLETE: 'complete'
};
